import React, { useState, useEffect } from "react"
import {
  Row, Col, Space, Tooltip, Dropdown, Modal, Button,
} from "antd"
import { UpCircleOutlined, DownOutlined, UpOutlined } from "@ant-design/icons"
import "../../../assets/stylesheets/rubrics/implementation/implementationRubric.scss"
import _, { last } from "underscore"
import ScrollToTop from "react-scroll-to-top"
import {
  areYouSure,
  errorAlert,
  findPreviousMonthRecord,
  formatTimestamp,
  isTenureCompleted,
} from "../../utilities"
import commonStrings from "../../commonStrings"
import HeaderButtons from "./Components/HeaderButtons"
import Collapsible from "./Components/Collapsible"
import ImplementationRubricStage from "./Stage"
import "animate.css"
import ImplementationReport from "./Report"
import ImplementationPlan from "./Plan"
import componentStyles from "../../styles"
import RubricsListing from "../rubrics/RubricsListing"
import SuccessAlert from "../rubrics/SuccessAlert"
import Loader from "../CommonComponents/Loader"
import CommonColors from "../../commonColors"
import IndicatorProgressReport from "./IndicatorProgressReport"
import backIcon from "../../../assets/images/back-icon.png"
import CSVUploadModal from "./CSVUploadModal"
import PlanImplicationsSummaryModal from "./PlanImplicationsSummaryModal"
import csvuploadIcon from "../../../assets/images/export-white.png"

const ImplementationRubric = ({
  rubric: rubricInitial,
  canCreate,
  rubricsList,
  currentSchool,
  rubricsDifference,
  type,
  rubricType,
  currentSchoolLists,
  schoolAssociatedWithRubrics,
}) => {
  const [flagRender, setFlagRender] = useState(0)
  const [submitting, setSubmitting] = useState(false)
  const [showPlan, setShowPlan] = useState(false)
  const [updatedRubric, setUpdatedRubric] = useState([])
  const [rubric, setRubric] = useState(rubricInitial)
  const [dropDownIconRotate, setDropDownIconRotate] = useState(false)
  const [dropDownIconRotateReports, setDropDownIconRotateReports] = useState(false)
  const [showListingSubmitted, setListingSubmitted] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [globalAiAnalyzing, setGlobalAiAnalyzing] = useState(false)
  const [monthlyScoreDiff, setMonthlyScoreDiff] = useState(null)
  const [latestUpdatedAt, setLatestUpdatedAt] = useState({})
  const [activeButton, setActiveButton] = useState("Show Report")
  const reportDate = new Date(rubric.updated_at).toLocaleDateString("en-US")
  const [labelClicked, setLabelClicked] = useState(false)
  const [selectedReports, setSelectedReports] = useState(
    "implementation-report",
  )
  const disableOnTenureCompletion = isTenureCompleted(rubric.created_at)
  const [showCSVModal, setShowCSVModal] = useState(false)
  const [showPlanSummaryModal, setShowPlanSummaryModal] = useState(false)

  function updateIndicatorWithRubric(obj, rubric) {
    const updatedIndicator = obj.indicators.map((indicator) => {
      const matchingRubric = rubric.find((r) => r.id === indicator.id)
      if (matchingRubric) {
        return {
          ...indicator,
          rating: matchingRubric.rating,
          explanation: matchingRubric.explanation,
          body: matchingRubric.body,
        }
      }
      return indicator
    })
    return {
      ...obj,
      indicators: updatedIndicator,
    }
  }

  function processObjects(objectsArray, listSchool) {
    const currentUrl = window.location.href

    if (currentUrl.includes("/implementation_rubrics/")) {
      const urlParts = currentUrl.split("/implementation_rubrics/")
      const idFromUrl = parseInt(urlParts[1], 10)
      const matchingObject = objectsArray.find((obj) => obj.id === idFromUrl)
      const SchoolbyId = matchingObject.school_id
      const matchingSchool = listSchool.find((obj) => obj.id === SchoolbyId)

      if (!matchingSchool) {
        window.location.href = "/"
      } else {
        setIsLoading(false)
      }
    }
  }
  useEffect(() => {
    processObjects(schoolAssociatedWithRubrics, currentSchoolLists)
  }, [schoolAssociatedWithRubrics, currentSchoolLists])
  const findObjectBeforeId = (array, targetId) => {
    const arrayOfObjects = array.filter((item) => item.submitted_at !== null)

    for (let i = 0; i < arrayOfObjects.length; i += 1) {
      if (arrayOfObjects[i].id === targetId) {
        if (i === 0) {
          return { updated_at: null }
        }
        if (_.isNull(arrayOfObjects[i - 1].submitted_at)) {
          return { updated_at: null }
        }
        return arrayOfObjects[i - 1]
      }
    }
    return { updated_at: null }
  }

  useEffect(() => {
    if (!_.isEmpty(updatedRubric)) {
      setRubric(updateIndicatorWithRubric(rubric, updatedRubric))
    }
  }, [updatedRubric])

  useEffect(() => {
    setListingSubmitted(false)
  }, [window.location.href])

  const unsubmitClicked = (type, rubric) => {
    areYouSure("info", () => {
      setSubmitting(true)
      APIClient.put(`/${type}_rubrics/${rubric.id}/unsubmit`, {}, () => {
        window.location.href = `/${type}_rubrics/${rubric.id}`
      })
    })
  }
  const handleErrors = (errors) => {
    setSubmitting(false)
    errorAlert({ html: errors.join("<br/><br/>") })
  }

  const confirmSubmit = (type, rubric) => {
    areYouSure("info", () => {
      setSubmitting(true)
      APIClient.put(
        `/${type}_rubrics/${rubric.id}/submit`,
        {},
        () => {
          const { id } = rubric

          APIClient.put(
            `/implementation_rubrics/${id}/generate_impl_progress_report`,
            {},
            () => {
              APIClient.put(
                `/clone_missing_indices?rubric_id=${id}`,
                {},
                () => {
                  window.location.href = `/${type}_rubrics/${rubric.id}`
                },
              )
            },
          )
        },
        (errors) => {
          handleErrors(errors)
        },
      )
    })
  }

  const submitClicked = (type, rubric) => {
    APIClient.put(
      `/${type}_rubrics/${rubric.id}/validate`,
      {},
      () => {
        confirmSubmit(type, rubric)
      },
      (errors) => {
        handleErrors(errors)
      },
    )
  }

  const deleteClicked = (type, rubric) => {
    areYouSure("warning", () => {
      APIClient.delete(`/${type.toLowerCase()}_rubrics/${rubric.id}`, () => {
        window.location.href = "/"
      })
    })
  }

  const createNewRubric = () => {
    if (!labelClicked && canCreate) {
      setLabelClicked(true)
      fetch("/implementation_rubrics/new").then((response) => {
        window.location.href = response.url
      })
    }
  }
  const calculateProgressionScore = () => {
    const parts = window.location.href.split("/")
    const idFound = parts[parts.length - 1]

    if (!idFound) return

    const findCurrentRubric = schoolAssociatedWithRubrics.find(
      (f) => f.id === parseInt(idFound, 10),
    )

    if (!findCurrentRubric || _.isNull(findCurrentRubric.results_details)) return

    const previousRecord = findPreviousMonthRecord(
      findCurrentRubric.results_details,
    )

    if (!previousRecord) return

    const previousScore = previousRecord.results.Overall
    const latestRecord = last(findCurrentRubric.results_details)

    if (!latestRecord) return

    const latestScore = latestRecord.results.Overall
    const scoreDifference = latestScore - previousScore
    setMonthlyScoreDiff(scoreDifference)
  }

  const ButtonHash = [
    // canCreate
    //   ? {
    //       textString: commonStrings.createNewRubric,
    //       backgroundColor: "#0CA4A5",
    //       color: "#FFFFFF",
    //       onClick: () => createNewRubric(),
    //     }
    //   : {},
    // dummy commit
    rubric.workflow_state === "draft" && !showListingSubmitted
      ? {
        textString: submitting ? "Submitting…" : commonStrings.generateReport,
        backgroundColor: "#A6192E",
        color: "#FFFFFF",
        onClick: () => submitClicked("implementation", rubric),
      }
      : {},
    // rubric.workflow_state === "submitted" && !showListingSubmitted
    //   ? {
    //       textString: !showPlan
    //         ? commonStrings.currentSchoolPlan
    //         : "Show Report",
    //       backgroundColor: "#33485D",
    //       color: "#FFFFFF",
    //       onClick: () => {
    //         setShowPlan(!showPlan);
    //         setListingSubmitted(false);
    //         setActiveButton(
    //           !showPlan ? commonStrings.currentSchoolPlan : "Show Report"
    //         );
    //       },
    //     }
    //   : {},
    rubric.workflow_state === "submitted" && !showListingSubmitted
      ? {
        textString: submitting
          ? commonStrings.unSubmitting
          : commonStrings.updateAndViewRubric,
        backgroundColor: "#ffc107",
        color: "#222529",
        onClick: () => {
          unsubmitClicked("implementation", rubric)
          setListingSubmitted(false)
        },
      }
      : {},

    // rubric.workflow_state === "submitted" &&
    //   (showListingSubmitted
    //     ? {}
    //     : {
    //         textString: "Indicator Progress Report",
    //         backgroundColor: "#ffc107",
    //         color: "#222529",
    //         onClick: () => {
    //           setActiveButton("Indicator Progress Report");
    //         },
    //       }),
  ]

  const implementationCollapse = [
    {
      id: 1,
      generalColor: "#A6192E",
    },
    {
      id: 2,
      generalColor: "#33485D",
    },
    {
      id: 3,
      generalColor: "#E7A922",
    },
    {
      id: 4,
      generalColor: "#0CA4A5",
    },
  ]

  const items = [
    {
      label: (
        <div style={{ fontFamily: "Archivo Narrow" }} className="">
          {commonStrings.viewRubrics}
        </div>
      ),
      key: "0",
      onClick: () => {
        setListingSubmitted(true)
        setActiveButton("View Rubrics")
      },
    },
    {
      label: (
        <div
          style={{ fontFamily: "Archivo Narrow" }}
          className={` ${!canCreate && "disabledDropdown"}`}
        >
          {commonStrings.createNewRubric}
        </div>
      ),
      key: "1",
      onClick: () => {
        if (canCreate) {
          createNewRubric()
        }
      },
      disabled: !canCreate,
    },
  ]
  const reportItems = [
    {
      label: (
        <div
          style={{ fontFamily: "Archivo Narrow" }}
          className={`${
            selectedReports === "implementation-report" ? "selected-report" : ""
          }`}
        >
          Implementation Report
        </div>
      ),
      key: "2",
      onClick: () => {
        setShowPlan(false)
        setListingSubmitted(false)
        setActiveButton("Show Report")
        setSelectedReports("implementation-report")
      },
      disabled: rubric.workflow_state === "draft",
    },
    {
      label: (
        <div
          style={{ fontFamily: "Archivo Narrow" }}
          className={`${
            selectedReports === "indicator-progress-report"
              ? "selected-report"
              : ""
          }`}
        >
          Indicator Progress Report
        </div>
      ),
      key: "3",
      onClick: () => {
        setSelectedReports("indicator-progress-report")
        setActiveButton("Indicator Progress Report")
      },
      disabled: rubric.workflow_state === "draft",
    },
    {
      label: (
        <div
          style={{ fontFamily: "Archivo Narrow" }}
          className={`${
            selectedReports === "current-school-plan" ? "selected-report" : ""
          }`}
        >
          Current School Plan
        </div>
      ),
      key: "4",
      onClick: () => {
        setShowPlan(true)
        setListingSubmitted(false)
        setActiveButton("Current School Plan")
        setSelectedReports("current-school-plan")
        // eslint-disable-next-line no-undef
        APIClient.post(`/implementation_rubrics/${rubric.id}/plan_implications_summary`, {}, () => {}, () => {})
      },
      disabled: rubric.workflow_state === "draft",
    },
  ]
  const indicatorsFor = (stage) => _.filter(rubric.indicators, (indicator) => indicator.stage === stage)

  function removeHtmlTags(inputString) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(inputString, "text/html")
    return doc.body.textContent || ""
  }
  const [tableListing, setTableListing] = useState([])
  useEffect(() => {
    // setLoading(true);
    APIClient.get(`/fetch_indicators_by_rubric/${rubric.id}`, (response) => {
      setTableListing(response)
      // setLoading(false);
    })
  }, [rubric.id])
  const tabContent = (index, generalColor) => (
    <div className="tab-content">
      <div key={index}>
        <ImplementationRubricStage
          type="Implementation"
          flagRender={flagRender}
          rubric={rubric}
          setFlagRender={setFlagRender}
          generalColor={generalColor}
          firstStage={index === 0}
          indicators={indicatorsFor(rubric.template.stages[index].name)}
          disabled={rubric.workflow_state === "submitted"}
          setUpdatedRubric={setUpdatedRubric}
          tableListing={tableListing}
          globalAiAnalyzing={globalAiAnalyzing}
          setGlobalAiAnalyzing={setGlobalAiAnalyzing}
        />
      </div>
    </div>
  )
  const showSuccessAlert = () => {
    if (
      (rubricsDifference > 0 || monthlyScoreDiff > 0)
      && !showListingSubmitted
      && !showPlan
    ) {
      return (
        <Col xs={24} sm={24} md={24} lg={24}>
          {rubric.detailed_result && rubric.detailed_result.length > 0 ? (
            monthlyScoreDiff > 0
            && rubric.workflow_state === "submitted" && (
              <SuccessAlert
                type={type}
                diff={monthlyScoreDiff}
                rubricType="implementation"
              />
            )
          ) : (
            <SuccessAlert
              type={type}
              diff={rubricsDifference}
              rubricType="implementation"
            />
          )}
        </Col>
      )
    }
    return null
  }

  const lastUpdate = () => {
    if (
      rubric
      && Array.isArray(rubric.rubric_update_history)
      && rubric.rubric_update_history.length > 0
    ) {
      const latestUpdate = _.first(
        rubric.rubric_update_history.sort((a, b) => b.id - a.id),
      ).created_at
      if (latestUpdate) {
        setLatestUpdatedAt(latestUpdate)
      } else {
        console.error("Error: 'created_at' is undefined.")
      }
    } else {
      console.error(
        "Error: 'rubric' is invalid or 'rubric_update_history' is not a valid non-empty array.",
      )
    }
  }

  useEffect(() => {
    calculateProgressionScore()
    lastUpdate()
    // This line is commented
    // setLatestUpdatedAt(_.first(rubric.rubric_update_history).created_at)
  }, [])

  const autoGenerateReport = () => {
    const { id } = rubric
    APIClient.post(
      `/implementation_rubrics/${id}/force_update_rubric`,

      {},
      () => {
        APIClient.put(
          `/implementation_rubrics/${id}/submit`,
          {},
          () => {
            window.location.reload()
          },
          () => {},
        )
      },
    )
  }

  const handleCSVUploadSuccess = () => {
    // Refresh indicators after successful upload
    APIClient.get(`/fetch_indicators_by_rubric/${rubric.id}`, (response) => {
      setTableListing(response)
      setFlagRender(flagRender + 1)
    })
    // Reload the page to get updated rubric data
    window.location.reload()
  }

  return isLoading ? (
    <Loader />
  ) : (
    <Row style={{ fontFamily: "Archivo Narrow" }}>
      <Row className="width50">
        <Col xs={24} sm={24} md={15} lg={15} className="px-1 headingNumbering">
          <div>
            <div className="d-flex align-items-center">
              {activeButton !== "Show Report" && (
                <span
                  onClick={() => {
                    window.location.reload()
                  }}
                >
                  <Tooltip title="Back to implementation report">
                    <img className="backIconSize" src={backIcon} />
                  </Tooltip>
                </span>
              )}
              <span className="font-weight-bold heading-color heading-size">
                {showListingSubmitted
                  ? "Implementation Rubrics"
                  : `Implementation Rubric #${rubric.number}`}
              </span>
            </div>
            <div>
              {(activeButton === "Show Report"
                || activeButton === "Current School Plan") && (
                <>
                  {!showListingSubmitted && (
                    <Col
                      className="status-block"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                    >
                      <span className="status-color">
                        {rubric.workflow_state === "submitted"
                          && (showPlan && !showListingSubmitted ? (
                            "Submitted"
                          ) : (
                            <div className="d-flex custom-css-ant-tooltip">
                              <Tooltip
                                title={commonStrings.lastUpdatedDate}
                                overlayClassName="custom-css-ant-tooltip"
                              >
                                <div className="">
                                  <span
                                    className="lastUpdated lineHeight"
                                    style={{
                                      color: CommonColors.UA_BOLD_BLACK,
                                    }}
                                  >
                                    <b>{commonStrings.lastUpdated}:&nbsp;</b>
                                  </span>
                                  <span className="lastUpdated lineHeight">
                                    {!_.isEmpty(latestUpdatedAt)
                                      ? new Date(
                                        latestUpdatedAt,
                                      ).toLocaleDateString("en-US")
                                      : "N/A"}
                                  </span>
                                </div>
                              </Tooltip>
                              &nbsp; &nbsp;
                              <Tooltip
                                title={commonStrings.lastSubmittedDate}
                                overlayClassName="custom-css-ant-tooltip"
                              >
                                <div className="">
                                  <span
                                    className="lastUpdated lineHeight"
                                    style={{
                                      color: CommonColors.UA_BOLD_BLACK,
                                    }}
                                  >
                                    <b>{commonStrings.lastSubmitted}:&nbsp;</b>
                                  </span>
                                  <span className="lastUpdated lineHeight">
                                    {reportDate}
                                  </span>
                                </div>
                              </Tooltip>
                            </div>
                          ))}
                      </span>
                    </Col>
                  )}
                </>
              )}
            </div>
          </div>
        </Col>
        {!showListingSubmitted && (
          <Col className="status-block" xs={24} sm={24} md={4} lg={4}>
            <span className="status-color">
              {rubric.workflow_state === "draft" && rubric.workflow_state}
            </span>
          </Col>
        )}
      </Row>

      <Row className="width50">
        <Col xs={24} sm={24} md={24} lg={24} style={componentStyles.centered}>
          <span className="d-flex justify-content-end">
            {ButtonHash.filter((props) => Object.keys(props).length > 0).map(
              (props, id) => {
                const isTenureCompletedValue = props.textString === commonStrings.updateAndViewRubric
                  ? !isTenureCompleted(rubric.created_at)
                  : true
                return (
                  isTenureCompletedValue && (
                    <HeaderButtons
                      key={id}
                      id={id}
                      textString={props.textString}
                      backgroundColor={props.backgroundColor}
                      color={props.color}
                      onClick={props.onClick}
                    />
                  )
                )
              },
            )}
          </span>

          {/* CSV Upload Button - Only show in draft mode for new schools */}
          {rubric.workflow_state === "draft" && !showListingSubmitted && (
            <span
              className="dropdown-rubric cursorPointer"
              style={{ marginRight: "8px" }}
            >
              <Button
                icon={(
                  <img
                    src={csvuploadIcon}
                    className="csv-upload-modal__file-icon"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "8px",
                    }}
                  />
                )}
                onClick={() => setShowCSVModal(true)}
                className="btnRubric"
                style={{
                  backgroundColor: "#0CA4A5",
                  color: "#FFFFFF",
                  border: "none",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Upload CSV
              </Button>
            </span>
          )}

          {/* {showPlan &&
            !showListingSubmitted &&
            rubric.workflow_state === "submitted" && (
              <span
                className="dropdown-rubric cursorPointer"
                style={{ marginRight: "8px" }}
              >
                <Button
                  icon={<BulbOutlined />}
                  onClick={() => setShowPlanSummaryModal(true)}
                  className="btnRubric"
                  style={{
                    backgroundColor: "#0CA4A5",
                    color: "#FFFFFF",
                    border: "none",
                    height: "35px",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Archivo Narrow",
                    width: "190px",
                  }}
                >
                  Plan Implications Summary
                </Button>
              </span>
            )} */}

          {activeButton !== "View Rubrics" && (
            <span
              className="dropdown-rubric cursorPointer"
              key={selectedReports}
            >
              <Dropdown
                onOpenChange={(state) => {
                  setDropDownIconRotateReports(state)
                }}
                className="btnRubric dropdownRubricImplementation"
                menu={{ items: reportItems }}
                trigger={["click"]}
              >
                <div>
                  <Space>
                    <span className="fontSize14">Reports</span>
                    <div className="mb-1">
                      {dropDownIconRotateReports ? (
                        <UpOutlined />
                      ) : (
                        <DownOutlined />
                      )}
                    </div>
                  </Space>
                </div>
              </Dropdown>
            </span>
          )}

          <span className="dropdown-rubric cursorPointer">
            <Dropdown
              onOpenChange={(state) => {
                setDropDownIconRotate(state)
              }}
              className="btnRubric dropdownRubricImplementation"
              menu={{
                items,
              }}
              trigger={["click"]}
            >
              <div>
                <Space>
                  <span className="fontSize14">Rubrics</span>
                  <div className="mb-1">
                    {dropDownIconRotate ? <UpOutlined /> : <DownOutlined />}
                  </div>
                </Space>
              </div>
            </Dropdown>
          </span>
        </Col>
      </Row>
      <Row>
        <Col
          id="current-school-plan-desc"
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="pt-4 pb-2"
        >
          {(activeButton === "Show Report"
            || activeButton === "Current School Plan") && (
            <>
              {rubric.workflow_state === "submitted"
                && !showListingSubmitted && (
                  <span id="current-school-plan-desc" className="paragraph">
                    {showPlan
                      ? commonStrings.implPlan
                      : commonStrings.implReport}
                  </span>
              )}
              {rubric.workflow_state === "draft" && !showListingSubmitted && (
                <span className="paragraph">{commonStrings.implRubric}</span>
              )}
            </>
          )}
        </Col>
      </Row>
      {showListingSubmitted && (
        <Col xs={24} sm={24} md={24} lg={24} className="mt-4">
          <RubricsListing
            rubricsList={rubricsList}
            rubricType="Implementation"
          />
        </Col>
      )}
      {(activeButton === "Show Report"
        || activeButton === "Current School Plan")
        && showSuccessAlert()}

      {(activeButton === "Show Report"
        || activeButton === "Current School Plan") && (
        <Col xs={24} sm={24} md={24} lg={24}>
          {rubric.workflow_state === "submitted" && (
            <>
              {!showPlan && !showListingSubmitted && (
                <ImplementationReport
                  rubric={rubric}
                  rubricListing={rubricsList}
                  generalColor={implementationCollapse}
                  reportDate={reportDate}
                  previousRubricUpdateDate={findObjectBeforeId(
                    rubricsList,
                    rubric.id,
                  )}
                  rubricNumber={`Implementation Rubric #${rubric.number} (${reportDate})`}
                  currentschoolLogo={rubric.logo_url}
                  currentSchoolName={currentSchool.name}
                  dateForReport={formatTimestamp(rubricInitial.updated_at)}
                  rubricType={rubricType}
                />
              )}
              {showPlan && !showListingSubmitted && (
                <ImplementationPlan
                  rubric={rubric}
                  reportHeadingTop={`Implementation Rubric #${rubric.number} Report  (${reportDate})`}
                  removeHtmlTags={removeHtmlTags}
                  currentSchoolName={currentSchool.name}
                  dateForReport={formatTimestamp(rubricInitial.updated_at)}
                  currentschoolLogo={rubric.logo_url}
                  onOpenPlanSummary={() => setShowPlanSummaryModal(true)}
                />
              )}
            </>
          )}
        </Col>
      )}

      {rubric.workflow_state === "draft" && !showListingSubmitted && (
        <Col>
          <Space direction="vertical" size={20} style={{ display: "flex" }}>
            {implementationCollapse.map((props, index) => (
              <Collapsible
                index={index}
                flagRender={flagRender}
                tabContent={() => tabContent(index, props.generalColor)}
                id={props.id}
                title={rubric.template.stages[index].name}
                subHeading={rubric.template.stages[index].heading}
                text={rubric.template.stages[index].description}
                generalColor={props.generalColor}
                indicators={indicatorsFor(rubric.template.stages[index].name)}
                disabled={rubric.workflow_state === "submitted"}
                firstStage={index === 0}
              />
            ))}
          </Space>
          <div className="my-4">
            {rubric.workflow_state === "draft" && (
              <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  deleteClicked("implementation", rubric)
                }}
              >
                Delete Rubric
              </button>
            )}
          </div>
        </Col>
      )}
      {activeButton === "Indicator Progress Report" && (
        <Col xs={24} sm={24} md={24} lg={24}>
          <IndicatorProgressReport
            rubric={rubric}
            tableListing={tableListing}
            currentSchool={currentSchool}
            disableOnTenureCompletion={disableOnTenureCompletion}
          />
        </Col>
      )}
      <div>
        <ScrollToTop
          style={{ border: "1px solid #7E7C7D", marginBottom: "140px" }}
          component={(
            <Tooltip
              placement="top"
              title={(
                <span style={{ fontWeight: "bolder" }}>
                  {commonStrings.scrollerText}
                </span>
              )}
            >
              <div className="animate__animated animate__bounceIn scrollerToTop d">
                <UpCircleOutlined />
              </div>
            </Tooltip>
          )}
          smooth
        />
      </div>

      <Modal
        open={
          isTenureCompleted(rubric.created_at)
          && rubric.workflow_state === "draft"
        }
        closable={false}
        width={500}
        title={<div className="noSchoolModal">{commonStrings.alert}</div>}
        footer={[
          <Button
            className="noSchoolModalButton"
            onClick={() => {
              autoGenerateReport()
            }}
          >
            {commonStrings.generateReport}
          </Button>,
        ]}
        centered
      >
        <b>{commonStrings.tenureCompletionAlert}</b>
      </Modal>

      {/* CSV Upload Modal */}
      <CSVUploadModal
        visible={showCSVModal}
        onClose={() => setShowCSVModal(false)}
        rubricId={rubric.id}
        onUploadSuccess={handleCSVUploadSuccess}
      />

      {/* Plan Implications Summary Modal */}
      <PlanImplicationsSummaryModal
        visible={showPlanSummaryModal}
        onClose={() => setShowPlanSummaryModal(false)}
        rubricId={rubric.id}
        rubricPlan={rubric.plan}
      />
    </Row>
  )
}

export default ImplementationRubric
